/* global Modernizr */

/**
 * handles the search-input and filters the elements containing the chars in the data-search-term attribute
 * @type Class
 */

export default class MultiSelector {

  constructor(el) {

    // doesn't initialize on touch devices
    // falls back to standard tc-selector
    if (Modernizr && Modernizr.touchevents) {

      return;
    }

    this.el = el;
    this.searchInput = this.el.querySelector('.tc-multi-selector-search input');
    this.searchListElements = [].slice.call(this.el.querySelectorAll('[data-search-term]'));

    if (!this.searchInput || !this.searchListElements) {

      return;
    }

    this.buildSearchArray();
    this.registerEvents();
  }

  registerEvents() {

    this.searchInput.addEventListener('keyup', this.updateSearch.bind(this), false);
  }

  buildSearchArray() {

    this.searchList = this.searchListElements.map(el => {

      this.searchTerm = el.getAttribute('data-search-term');

      if (this.searchTerm) {

        return {
          'term': this.searchTerm.toLowerCase(),
          'element': el
        };
      }
    });
  }

  updateSearch() {

    if (!this.searchList || !this.searchList.length) {

      this.searchInput.removeEventListener('keyup', this.updateSearch.bind(this), false);
      return;
    }

    const query = this.searchInput.value.toLowerCase();

    this.searchList.map(item => {

      if (item.term.match(new RegExp(query, 'g'))) {

        item.element.classList.remove('no-match');
      } else {

        item.element.classList.add('no-match');
      }
    });
  }
};
